import { Badge } from "@/components/ui/badge";
import { SnapshotDetails } from "@/lib/api/mentor-scoring";
import { ColumnDef } from "@tanstack/react-table";


export const columns: ColumnDef<SnapshotDetails>[] = [
  {
    accessorKey: "teen_name",
    header: "Teen",
    cell: ({ row }) => {
      const name = row.original.teen.first_name + " " + row.original.teen.last_name;
      return (
        <div className="max-w-[300px] truncate flex justify-center">
          <Badge variant="outline">{name}</Badge>
        </div>
      );
    },
  },
  {
    accessorKey: "points_earned",
    header: "Points earned",
    cell: ({ row }) => {
      const points = row.original.points_earned;
      return (
        <div className="max-w-[300px] truncate flex justify-center">
          <Badge variant="outline">{points}</Badge>
        </div>
      );
    },
  },
  {
    accessorKey: "average_rating",
    header: "Average rating",
    cell: ({ row }) => {
      let rating = row.original.average_rating;
      if(!rating) {rating = "N/A";}
      return (
        <div className="max-w-[300px] truncate flex justify-center">
          <Badge variant="outline">{rating}</Badge>
        </div>
      );
    },
  },
  {
    accessorKey: "first_week_engagement",
    header: "First week unique days",
    cell: ({ row }) => {
      const score = row.original.first_week_unique_days;
      return (
        <div className="max-w-[300px] truncate flex justify-center">
          <Badge variant="outline">{score}</Badge>
        </div>
      );
    },
  },
  {
    accessorKey: "month1_retention",
    header: "Teen retained on month 1",
    cell: ({ row }) => {
      const score = row.original.month1_retention;
      let engaged = "✕";
      if(score) {engaged = "✔";}
      return (
        <div className="max-w-[300px] truncate flex justify-center">
          <Badge variant="outline">{engaged}</Badge>
        </div>
      );
    },
  },
  {
    accessorKey: "month3_retention",
    header: "Teen retained on month 3",
    cell: ({ row }) => {
      const score = row.original.month3_retention;
      let engaged = "✕";
      if(score) {engaged = "✔";}
      return (
        <div className="max-w-[300px] truncate flex justify-center">
          <Badge variant="outline">{engaged}</Badge>
        </div>
      );
    },
  },
];
